/**************************************************
 * Nombre:       Tours_Portada
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {Splide, SplideSlide} from "@splidejs/react-splide";
import '@splidejs/react-splide/css';
import uno from '../../../Recursos/fondo_uno.png'
import dos from '../../../Recursos/fondo_dos.png'
import tres from '../../../Recursos/fondo_tres.png'
import {CATEGORIAS} from "../../../Constantes";
import Tarjeta_Categorias from "../../Tarjetas/Tarjeta_Categorias";
import {useResponsive} from "../../../Modulo_responsive/Hooks/useResponsive";

const Tours_Portada = ({seleccionado, setSeleccionado}) => {
    const {sCell, masSM} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}>

            <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', zIndex: 1}}>
                <Splide
                    aria-label="My Favorite Images" style={{width: '100%'}}
                    options={{
                        autoplay: true,
                        speed: 5000,
                        rewind: true,
                        perPage: 1,
                        perMove: 1,
                        arrows: false,
                        pagination: true,
                        width: '100%',
                        drag: 'false',
                        interval: 8000,
                        noDrag: true,
                        gap: 0,
                        type: 'fade'

                    }}
                >

                    {items.map((srcImg, index) => {
                        return (
                            <SplideSlide key={`qe${index}`}>
                                <Grid
                                    container
                                    justifyContent={'flex-start'}
                                    alignItems={'flex-start'}
                                    size={{xs: 12, sm: 12, md: 12}}
                                    sx={{
                                        background: `linear-gradient(0deg, rgba(0, 0, 0, 0.80) 0.25%, rgba(0, 0, 0, 0.00) 70.49%), url(${srcImg})`,
                                        height: 550,
                                        width: '100%',
                                        backgroundRepeat: 'no-repeat',
                                        backgroundSize: 'cover',
                                        backgroundPosition: 'center',
                                    }}
                                >


                                </Grid>
                            </SplideSlide>
                        )
                    })}


                </Splide>
            </Grid>


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', mt: sCell ? -48 : -34, zIndex: 2}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontSize: sCell ? 40 : 48, fontWeight: 800}}>Nuestros Tours</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'center'}}>
                    <Typography sx={{fontSize: 16, fontWeight: 500, lineHeight: 1.1, textAlign: 'center'}}>Explora lo
                        mejor de San Andrés con
                        nuestros tours
                        de aventura, mar y tierra. Cada experiencia está diseñada para sorprenderte y conectar
                        contigo.</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 8}} sx={{justifyContent: 'flex-start', mt: 3}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}
                        spacing={2}
                    >

                        {CATEGORIAS.map((it, index) => {
                            return (
                                <Grid
                                    onClick={() => setSeleccionado(it)}
                                    container size={{xs: 6, sm: 4, md: 3}}
                                    sx={{justifyContent: 'flex-start', mt: sCell ? 0 : 2}}>
                                    <Tarjeta_Categorias item={it}/>
                                </Grid>
                            )
                        })}

                    </Grid>
                </Grid>

            </Grid>


        </Grid>
    )

}
export default Tours_Portada

const items = [
    uno, dos, tres
]